import IconFirstBlood from './IconFirstBlood';

export default IconFirstBlood;